import { useState } from 'react';

export default function Hoverable({
  as: Tag = 'div',
  base,
  hover,
  style,
  children,
  ...rest
}) {
  const [isHover, setIsHover] = useState(false);
  return (
    <Tag
      style={{ ...base, ...style, ...(isHover ? hover : null) }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...rest}
    >
      {children}
    </Tag>
  );
}
